import Slide from '@material-ui/core/Slide';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { IMiaRouteMatchResponse } from '../components/hooks';
import { ListItemLoading } from '../components/ListItemLoading';
import { DRAWER_WIDTH } from './layoutConstants';
import { SidebarContext } from './SidebarContext';

interface IRightSidebarProps {
  matchingRoutes: IMiaRouteMatchResponse | null;
}

const useStyles = makeStyles(() => createStyles({ root: { width: DRAWER_WIDTH, overflow: 'auto', paddingBottom: 5 } }));

let RightSidebar: React.FunctionComponent<IRightSidebarProps> = ({ matchingRoutes }) => {
  const { isOpen } = React.useContext(SidebarContext);
  const classes = useStyles();

  const sidebar = React.useMemo(
    () => matchingRoutes?.currentRoute.route.sidebar ?? matchingRoutes?.rootRoute.route.sidebar,
    [matchingRoutes]
  );

  return (
    <ErrorBoundary>
      {sidebar ? (
        <Slide in={isOpen} direction="left" unmountOnExit>
          <div className={classes.root}>
            <React.Suspense fallback={<ListItemLoading />}>{sidebar.component}</React.Suspense>
          </div>
        </Slide>
      ) : null}
    </ErrorBoundary>
  );
};

RightSidebar = React.memo<IRightSidebarProps>(RightSidebar);
export { RightSidebar };
